import webApi, { baseURL } from "../../WebApi/WebApi";

export const getAllProductDetailslist = async (
  supplierName,
  vat,
  month,
  isToggledData = false,
  data,
  fromDate,
  toDate,
  page = 1,
  signal,
  perPage
) => {
  // console.log(supplierName, vat, data, "dsaasddsaasd");
  return await webApi.post(
    `/customer/product/list-product?searchKeyword=${data ? data : ""}`,
    {
      supplierName: supplierName ? supplierName.flat() : [],
      isVatPasent: vat ? vat : "",
      month: month ? month : "",
      isToggleddata: isToggledData,
      fromDate: fromDate ? fromDate : "",
      toDate: toDate ? toDate : "",
      page: page + 1,
      limit: perPage,
    },
    {
      signal: signal,
    }
  );
};

//supplier list
export const getInvoiceSupplierList = async (data) => {
  return await webApi.get(`/customer/invoice/list-suppliers`, {});
};
export const getInvoiceSupplierListCommon = async (data) => {
  return await webApi.get(`/customer/invoice/list-suppliers-common`, {});
};

export const getSegmentList = async (data) => {
  return await webApi.get(`/customer/segment/list-user-segment`, {});
};

export const getUnspcAdd = async (
  unspscData,
  products,
  onSuccess,
  onFailure
) => {
  // console.log("unspscData");
  // console.log(unspscData);
  // console.log(products);

  try {
    const res = await webApi.post(`/customer/product/edit-unspsc-for-product`, {
      unspscData: {
        value: unspscData.value.code,
        title: unspscData.value.title,
        id: unspscData.value.id,
      },
      products,
      // products,
      point: unspscData.value.point,
    });
    if (res.status === 200) {
      const r = res.data;
      // console.log(r, "rerere");
      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    // console.log("fdgdf");
  }
};

export const addUnspscData = async (
  unspscData,
  products,
  onSuccess,
  onFailure
) => {
  // console.log("unspscData");
  // console.log(unspscData);
  // console.log(products);

  try {
    const res = await webApi.post(`/customer/product/edit-unspsc-for-product`, {
      unspscData: {
        value: unspscData.code,
        title: unspscData.title,
        id: unspscData.id,
      },
      products,
      point: unspscData.point,
    });
    if (res.status === 200) {
      const r = res.data;
      // console.log("Response");
      // console.log(r);
      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    // console.log("fdgdf");
  }
};

export const addUNSPSCPastOrder = async (
  unspscData,
  userInvoiceId,
  ItemId,
  ItemName,
  pastOrderId,
  onSuccess,
  onFailure
) => {
  try {
    const res = await webApi.post(
      `/customer/past-order/add-unspsc-past-order`,
      {
        unspscData: {
          value: unspscData.value.code,
          title: unspscData.value.title,
          id: unspscData.value.id,
        },
        point: unspscData.value.point,
        userInvoiceId: userInvoiceId,
        ItemId: ItemId,
        ItemName: ItemName,
        pastOrderId: pastOrderId,
      }
    );
    if (res.status === 200) {
      const r = res.data;
      // console.log(r, "rerere");
      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    // console.log("fdgdf");
  }
};

// get-product-by-id
export const getProductById = async (productId, onSuccess, onFailure) => {
  try {
    const res = await webApi.post(`/customer/product/get-product-by-id`, {
      productId,
    });
    if (res.status === 200) {
      const r = res.data;
      // console.log(r, "rerere");
      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    // console.log("fdgdf");
  }
};

export const getActiveProduct = async (
  module,
  id,
  isactive,
  onSuccess,
  onFailure
) => {
  try {
    const res = await webApi.post(`/customer/common/is-active`, {
      module: module,
      id: id,
      isActive: isactive,
    });
    if (res.status === 200) {
      const r = res.data;
      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    // console.log("fdgdf");
  }
};

export const getFamilyList = async (segmentCode, onSuccess, onFailure) => {
  try {
    const res = await webApi.post(`/customer/unspsc/list-unspsc`, {
      segmentCode: segmentCode,
      count: 100,
    });
    if (res.status === 200) {
      const r = res.data;
      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    // console.log("fdgdf");
  }
};

export const getClassList = async (
  segmentCode,
  familyCode,
  onSuccess,
  onFailure
) => {
  try {
    const res = await webApi.post(`/customer/unspsc/list-unspsc`, {
      segmentCode: segmentCode,
      familyCode: familyCode,
      count: 100,
    });
    if (res.status === 200) {
      const r = res.data;
      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    // console.log("fdgdf");
  }
};

export const getCommodityUnspcList = async (
  segmentCode,
  familyCode,
  classCode,
  onSuccess,
  onFailure
) => {
  try {
    const res = await webApi.post(`/customer/unspsc/list-unspsc`, {
      segmentCode: segmentCode,
      familyCode: familyCode,
      classCode: classCode,
      count: 100,
    });
    if (res.status === 200) {
      const r = res.data;
      // console.log(r, "rerere");
      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    // console.log("fdgdf");
  }
};

export const updateBaseQty = async (data, onSuccess, onFailure) => {
  try {
    const res = await webApi.post(
      `/customer/product/edit-base-quantity-for-product`,
      data
    );
    if (res.status === 200) {
      const r = res.data;
      // console.log(r, "rerere");
      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    // console.log("fdgdf");
  }
};
